import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import { withRouter } from 'react-router';

import { DatePickerField, SelectField } from 'Common/SemanticWrapper';
import { GenericExportFieldEnum as Fields } from 'Common/FieldEnum';
import { MONTH_YEAR_DATE_FORMAT } from 'Common/Constants';
import { GENERIC_EXPORT_FORM_NAME } from 'Common/FormEnum';
import { YesNoOptions, makeOptionsData } from 'Common/FormHelper';
import SelectSitesTable from 'Common/SelectSitesTableReduxForm';
import { TitledCard } from 'Components/';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';

class GenericExportFormContainter extends Component {
  render() {
    const { handleSubmit, loading, exportFileType } = this.props;

    return (
      <Fragment>
        <Form onSubmit={handleSubmit} name={GENERIC_EXPORT_FORM_NAME}>
          <TitledCard title={'Filters'}>
            <Grid columns={1}>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Field
                    name={Fields.ExportFileType}
                    component={SelectField}
                    options={makeOptionsData(exportFileType)}
                    label={'File Type'}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={Fields.MonthYearDT}
                    component={DatePickerField}
                    dateFormat={MONTH_YEAR_DATE_FORMAT}
                    maxDate={moment()}
                    label="Month/Year"
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column className="input-group--btn-group">
                  <ReduxFormButtonGroup
                    label={"Pad numeric values with 0's to the left"}
                    formName={GENERIC_EXPORT_FORM_NAME}
                    options={YesNoOptions}
                    fieldName={Fields.PadValuesWithZero}
                    disabled={loading}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={Fields.SelectedSites}
                    component={SelectSitesTable}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Form>
      </Fragment>
    );
  }
}

const validate = (values, props) => {
  let errors = {};

  if (!values[Fields.ExportFileType]) {
    errors[Fields.ExportFileType] = 'File Type must be selected.';
  }

  if (!values[Fields.SelectedSites] || !values[Fields.SelectedSites].length) {
    errors[Fields.SelectedSites] = 'At least one site must be selected.';
  }

  if (!moment(values[Fields.MonthYearDT], MONTH_YEAR_DATE_FORMAT).isValid()) {
    errors[Fields.MonthYearDT] = 'A valid month/year must be selected.';
  }
  return errors;
};

export default reduxForm({
  form: GENERIC_EXPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(GenericExportFormContainter));



// WEBPACK FOOTER //
// ./src/pages/genericexport/components/GenericExportForm.js